import { Injectable } from '@angular/core';
import {ISamAgent} from "../../libraries/service/resources/sam/ISamAgent";
import {ISamCompany} from "../../libraries/service/resources/sam/ISamCompany";
import {
    IAirCreateBookingRequestAgency,
    IAirCreateBookingRequestAgent
} from "../../libraries/service/resources/model/booking/air/IAirCreateBooking";

@Injectable({
  providedIn: 'root'
})
export class AgentAgencyService {

    public buildAgentAndAgency(agent?: ISamAgent, company?: ISamCompany, propalResponse?: any): {
        agent: any;
        agency: IAirCreateBookingRequestAgency
    } {
        const {simpleAgent, simpleAgency}: { simpleAgent: any, simpleAgency: any } = this.getAgentAndAgency(propalResponse);
        const theAgent: any = !simpleAgent || simpleAgent.length === 0 ? this.createAgentFromSamAgent(agent) : simpleAgent;

        return {
            agent: theAgent,
            agency: this.buildAgency(company, simpleAgency),
        };
    }

    private getAgentAndAgency(propalResponse?: any): { simpleAgent: any, simpleAgency: any } {
        const $post = JSON.parse(sessionStorage.getItem('$post'));
        let data: any;
        data = $post || propalResponse?.searchForm || propalResponse?.searchRQ;

        if(data?.body){
            data = data?.body;
        }
        const searchForm: any = propalResponse?.searchForm;
        let searchRq: any = propalResponse?.searchRQ;
        if(searchRq?.body){
            searchRq = searchRq.body;
        }

        const simpleAgentPost: any = this.getSimpleParam('agent', data);
        const simpleAgencyPost: any = this.getSimpleParam('agency', data);
        const simpleAgentSearchRq: any = this.getSimpleParam('agent', searchRq);
        const simpleAgencySearchRq: any = this.getSimpleParam('agency', searchRq);
        return {
            simpleAgency: this.hasData(simpleAgencyPost)? simpleAgencyPost : simpleAgencySearchRq,
            simpleAgent: this.hasData(simpleAgentPost)? simpleAgentPost  : simpleAgentSearchRq
        };
    }

    private getSimpleParam(param: any, source: any): any {
        if(source){
            let output: any = {};
            output = source[param];
            return output;
        }
        return null;
    }

    private hasData(obj: object): boolean{
        return Boolean(obj) ?
            Boolean(Object.keys(obj).length):
            Boolean(obj);
    }

    private createAgentFromSamAgent(agent: ISamAgent): IAirCreateBookingRequestAgent {
        return {
            firstName: agent.firstName,
            lastName: agent.lastName,
            name: agent.name,
            ...agent.link && agent.link.email ? {email: agent.link.email} : {},
            ...agent.link && (agent.link.phone || agent.link.mobile) ? {telephone: agent.link.phone || agent.link.mobile} : {},
        };
    }

    private buildAgency(samCompany: ISamCompany, requestAgency: any): IAirCreateBookingRequestAgency {
        if (!requestAgency || requestAgency.length === 0) {
            return samCompany;
        }

        if (requestAgency && !requestAgency.telephone) {
            requestAgency.telephone = samCompany.link.mobile || samCompany.link.phone;
        }

        if (requestAgency && !requestAgency.address) {
            requestAgency.address = samCompany.address;
        }

        // @ts-ignore
        if (!requestAgency.name && requestAgency.Name) {
            // @ts-ignore
            requestAgency.name = requestAgency.Name;
            // @ts-ignore
            delete requestAgency.Name;
        }
        // @ts-ignore
        if (!requestAgency.code && requestAgency.Code) {
            // @ts-ignore
            requestAgency.code = requestAgency.Code;
            // @ts-ignore
            delete requestAgency.Code;
        }

        return requestAgency;
    }
}
